import React, { PropsWithChildren } from 'react';

import { useRoute } from 'hooks/navigation/use-route';
import { RunningExperiments, useExperiments } from 'state/experiments';

export function DisableFabForHomePage__Experiment(props: PropsWithChildren<{}>) {
  const { variant } = useExperiments();
  const { pathname } = useRoute();

  if (pathname === '/' && variant(RunningExperiments.SimpleHomePage, 'treatment')) {
    return null;
  }

  return props.children ? <>{props.children}</> : <></>;
}
